
import Error from "@/components/Error.vue";
import { defineComponent } from "vue";

export default defineComponent({
  components: { Error },
});
